import React, { useState } from "react";
import { ArrowUpRight, Check } from "lucide-react";
import { services } from "../mock";
import IntakeModal from "./IntakeModal";

const Services = () => {
  const [intake, setIntake] = useState(null); // { title, lookupKey, price } | null

  return (
    <section id="services" className="relative py-28 md:py-36 cosmic-panel overflow-hidden">
      <div className="stars opacity-60" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center max-w-3xl mx-auto">
          <div className="divider-star justify-center"><span>Signature Services</span></div>
          <h2 className="font-serif text-4xl md:text-6xl leading-[1.05] mt-8 text-[#EDE3D0]">
            Five sacred containers.
            <span className="block italic text-[#D4A85B] mt-1">Choose the one your soul is calling for.</span>
          </h2>
          <p className="mt-6 text-[#EDE3D0]/75 leading-relaxed">
            Every offering is a personalized blend of psychology, spirituality, and nervous-system care —
            designed to help you move beyond survival and into alignment.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => (
            <article
              key={s.id}
              className={`relative rounded-3xl border p-8 md:p-10 transition duration-500 overflow-hidden ${
                s.featured
                  ? "border-[#D4A85B] bg-[#0F0821] shadow-[0_30px_90px_-30px_rgba(212,168,91,0.35)]"
                  : "border-[#D4A85B]/25 bg-[#12081E]/70 hover:border-[#D4A85B]/60"
              }`}
            >
              {s.featured && (
                <div className="absolute top-6 right-6 flex items-center gap-2 text-[10px] uppercase tracking-[0.32em] text-[#D4A85B]">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#D4A85B]" />
                  Signature
                </div>
              )}

              <div className="flex items-start justify-between gap-6">
                <div>
                  <div className="font-display text-xs text-[#D4A85B]">{s.number}</div>
                  <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4A85B]/80 mt-1">{s.kind}</div>
                  <h3 className="font-serif text-3xl md:text-4xl mt-3 text-[#EDE3D0] leading-tight">{s.title}</h3>
                  <p className="mt-3 text-[#EDE3D0]/75 leading-relaxed max-w-md">{s.subtitle}</p>
                </div>
                <div className="text-right shrink-0">
                  <div className="font-serif text-4xl text-[#D4A85B]">{s.price}</div>
                  <div className="text-[10px] uppercase tracking-[0.24em] text-[#EDE3D0]/60 mt-1">{s.duration}</div>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-[#D4A85B]/15">
                <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4A85B]/80 mb-4">
                  {s.id === "nervous-system-reset" ? "What's included" : s.id === "spiritual-alignment" ? "What we weave together" : "Perfect for"}
                </div>
                <ul className="grid grid-cols-2 gap-x-4 gap-y-2">
                  {s.perfectFor.map((b) => (
                    <li key={b} className="flex items-start gap-2 text-sm text-[#EDE3D0]/85">
                      <Check size={14} className="text-[#D4A85B] shrink-0 mt-0.5" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <button
                type="button"
                onClick={() => setIntake({ title: s.title, lookupKey: s.stripeLookupKey, price: s.price })}
                data-testid={`service-book-${s.id}`}
                className="mt-8 inline-flex items-center gap-2 text-[#D4A85B] text-xs uppercase tracking-[0.28em] hover:gap-3 transition-all cursor-pointer"
              >
                {s.cta} · {s.price} <ArrowUpRight size={15} />
              </button>
            </article>
          ))}
        </div>

        <div className="mt-14 text-center text-sm text-[#EDE3D0]/60">
          Interest-free payment plans available on every offering. Superbills provided on request.
        </div>
      </div>

      <IntakeModal
        open={!!intake}
        onClose={() => setIntake(null)}
        preselectedService={intake?.title || ""}
        serviceLookupKey={intake?.lookupKey || ""}
        servicePrice={intake?.price || ""}
      />
    </section>
  );
};

export default Services;
